import { createNotesContextProvider } from 'src/SharedCommonContext/GenericNotesContextFactory';

export const {
  NotesProvider: SuiteNotesProvider,
  useNotesDataFromContext: useSuiteNotesDataFromContext,
  useNotesActionsFromContext: useSuiteNotesActionsFromContext,
} = createNotesContextProvider({
  itemType: 'Suite',
  displayName: 'suite',
});
